import styled from 'styled-components'

export const StageBanner = styled.div`
  width: 100%;
  background-color: #fe323d;
  opacity: 100%;
  height: 34px;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 10px;
  @media (max-width: 640px) {
    height: 45px;
  }
`

export const BannerText = styled.h1`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 14px;
  color: white;
`

export const BannerLink = styled.a`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 14px;
  color: white;
`
